import * as React from "react";

export type InjectedProps = {
  onSubmitFailure: (message: string | null | undefined) => void;
  errorMessage?: string | null | undefined;
};

export function withSubmitErrorHandler<P extends object>(
  Component: React.ComponentType<P & InjectedProps>
) {
  const WithErrorState = (props: P) => {
    const [error, setError] = React.useState<any>(null);
    return (
      <Component
        {...props}
        onSubmitFailure={setError}
        stripeErrorMessage={error}
      />
    );
  };

  return WithErrorState;
}
